/* Kkumi shared HTML-escaper (JS side).
 *
 * ONE canonical escaper for asset scripts that build markup at runtime, so the
 * hand-rolled per-file copies can't drift (one previously omitted the
 * apostrophe). Loaded globally from theme.liquid before the section scripts.
 * Matches the Liquid `| escape` filter's character set (& < > " ').
 *
 * Usage (inside a section IIFE):  var esc = window.KKEsc;
 *   el.innerHTML = '<b>' + esc(apiValue) + '</b>';
 */
(function () {
  var MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  window.KKEsc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return MAP[c]; });
  };
})();
